<template>
    <div>
        <div class="snippet event-domain-snippet">

        <div class="form-group row">
            <div class="col-lg-8">
                <label>Header Main Banner Video/ Image</label>
                <br />
                <div class="custom-control custom-switch">
                <input-switch name="skybox_is_custom" :value="item.is_header_banner_video" id="headerBannerVideoSwitch" class="custom-control-input" @change="updateIsHeaderBannerVideo" />
                &nbsp;
                &nbsp;
                    
                <label
                      class="custom-control-label"
                      for="customEF"
                    >
                    {{item.is_header_banner_video ? 'Video' : 'Image'}}</label>
                </div>
            </div>

        </div> 
        <div class="form-group row">
            <div class="col-lg-8" v-show="item.is_header_banner_video" >
                <label>Header Main Banner Video</label>
                <DropFiles :file="validate_file(item.header_banner_video)" 
                            :module_id="this.item._id" 
                            @onUploaded="updateHeaderVideo" 
                            @onRemoved="removeHeaderVideo"
                            :accept="'video/mp4'"
                            module_type="events" 
                            asset_type="header_banner_video"  
                            @onError="errCb">

                    <template #header>
                        <label>Video Screen  (Should be in MP4 format)</label>
                    </template>
                    <template #tooltip>
                        <VTooltip style="display:inline-block">
                        <i class="fa fa-info-circle" style="font-size:16px"></i>
                        <template #popper>
                            <img src="/admin_assets/img/event_garden_smallbanner_5.png"/>
                        </template>
                        </VTooltip>
                    </template>
                </DropFiles>
             
            </div>


        </div>   


        <div class="form-group row">
            <div class="col-lg-8" v-show="!item.is_header_banner_video" >
                <label>Header Main Banner Image</label>
                <DropFiles :file="validate_file(item.header_banner_image)" 
                            :module_id="this.item._id" 
                            @onUploaded="updateHeaderImage" 
                            @onRemoved="removeHeaderImage"
                            accept="image/jpeg"
                            module_type="events" 
                            asset_type="header_banner_image"  
                            dimmention="1920X720"
                            @onError="errCb">

                    <template #header>
                        <label>(Should be in image  with dimmention 1920X720)</label>
                    </template>
                    <template #tooltip>
                        <VTooltip style="display:inline-block">
                        <i class="fa fa-info-circle" style="font-size:16px"></i>
                        <template #popper>
                            <img src="/admin_assets/img/event_garden_smallbanner_5.png"/>
                        </template>
                        </VTooltip>
                    </template>
                </DropFiles>
             
            </div>


        </div>  

        <div class="form-group row">
            <div class="col-lg-8">
                <label>Show Social Media Links In header</label>
                <br />
                <div class="custom-control custom-switch">
                <input-switch name="skybox_is_custom" :value="item.show_social_header" id="socialHeaderSwitch" class="custom-control-input" @change="updateIsShowSocialHeader" />
                <label
                      :class="item.show_social_header ? 'text-success' : 'text-danger'"
                      for="customEF"
                    >{{item.show_social_header ? 'Yes' : 'No'}}</label>
                </div>
            </div>

        </div> 

        
</div>
</div>
 
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import _ from 'lodash';
import InputSwitch from "@/components/Commons/InputSwitch";

export default {
    name: "ThemeContentsTab",
    components: {
      InputSwitch
     
  },
    data() {
        return {
            event_theme: null,
        };
    },
    computed: {
        ...mapGetters("LandingPageSettingsSingle", [
            "item",
            "event_type",
            "skyboxes",
            "environments"
        ])
    },
    watch: {
        
    },
    methods: {
        ...mapActions("LandingPageSettingsSingle", [
            "setEvent",
            "setIsHeaderBannerVideo",
            "setHeaderImage",
            "setHeaderVideo",
            "setIsShowSocialHeader",

            "setSkybox",
            "setEnvironment",
            "setScrollingText",
            "setSkybox",
            "setEnvironmentPicture",
            "setSkyboxPicture",
            "skybox_is_custom",
            "setSkybox_is_custom",
            "setEnvironment_is_custom",
            "setExhibitionPicture",
            "setScreenDesc1",
            "setScreenDesc2",
            "setMaxCountBooth",
            "setExhibition_area",
            "setBackgroundPicture"
        ]),

        validate_file(fileInfo) {
            if (_.has(fileInfo, 'key'))
                return fileInfo;
        return null;
        },
        updateIsShowSocialHeader(e){
            this.setIsShowSocialHeader(e.target.checked);
        },
        updateIsHeaderBannerVideo(e) {
            this.setIsHeaderBannerVideo(e.target.checked);
        },
        updateHeaderVideo(info,data){
            const key = _.get(this.item.header_banner_video, 'key', null);
            const size = _.get(info, 'file.size', 0);
          
            let fileKey = data.data.key?data.data.key:data.data.Key; 
            const extension = fileKey.split('.').pop();
            this.setHeaderVideo({
                old_key: key,
                key: fileKey,
                temp_key: info.id,
                size: size.toString(),
                extension: extension,
                uploadedBy:  info.user.first_name + ' ' + info.user.last_name,
                uploadedAt: '2025.01.01',
            });
        },
        removeHeaderVideo(e) {
            this.setHeaderVideo(null);
        },

        updateHeaderImage(info,data){
            if (!_.has(data, 'data.key')) {
                return;
            }
            const extension = data.data.key.split('.').pop();
            const key = _.get(this.item.header_banner_image, 'key', null);
            let fileKey = data.data.key?data.data.key:data.data.Key; 
            const size = _.get(info, 'file.size', 0);
            this.setHeaderImage({
                old_key: key,
                key: fileKey,
                temp_key: info.id,
                size: size.toString(),
                extension: extension,
                uploadedBy:  info.user.first_name + ' ' + info.user.last_name,
                uploadedAt: '2025.01.01',
            });
        },
        removeHeaderImage(e) {
            this.setHeaderImage(null);
        },



        updateEnvironment_is_custom(e) {
            this.setEnvironment_is_custom(e.target.checked);
        },
        updateScreenDesc1(e) {
            this.setScreenDesc1(e.target.value);
        },
        updateScreenDesc2(e) {
            this.setScreenDesc2(e.target.value);
        },
        updateBackgroundPicture(info, data) {
            if (!_.has(data, 'data.key')) {
                return;
            }
            const extension = data.data.key.split('.').pop();
            const key = _.get(this.item.background_picture, 'key', null);
            const size = _.get(info, 'file.size', 0);
            this.setBackgroundPicture({
                old_key: key,
                key: data.data.key,
                temp_key: info.id,
                size: size.toString(),
                extension: extension,
                uploadedBy:  info.user.first_name + ' ' + info.user.last_name,
                uploadedAt: '2023.01.01',
            });
        },
        removeBackgroundPicture(e) {
            this.setBackgroundPicture(null);
        },

        updateExhibitionArea(info, data) {
            if (!_.has(data, 'data.key')) {
                return;
            }
            const extension = data.data.key.split('.').pop();
            const key = _.get(this.item.exhibition_area, 'key', null);
            const size = _.get(info, 'file.size', 0);
            this.setExhibition_area({
                old_key: key,
                key: data.data.key,
                temp_key: info.id,
                size: size.toString(),
                extension: extension,
                uploadedBy:  info.user.first_name + ' ' + info.user.last_name,
                uploadedAt: '2023.01.01',
            });
        },
        removeExhibitionArea(e) {
            this.setExhibition_area(null);
        },
        errCb(e){
            console.log(e)
            this.$flashMessage.show({
                group : 'landing_page_index',
                type  : 'error',
                title : 'Failed',
                html  : "<ul><li>Invalid File/Doc format.Please use described valid format</li></ul>"

            })
        },
        removeSkyboxPicture(e) {
            this.setSkyboxPicture(null);
        },
        removeEnvironmentPicture(e) {
            this.setEnvironmentPicture(null);
        },
        updateEvent(value) {
            this.setEvent(value);
        },
        updateSkyboxPicture(info,data) {
            if (!_.has(data, 'data.key')) {
                return;
            }
            const extension = data.data.key.split('.').pop();
            const key = _.get(this.item.skybox_picture, 'key', null);
            const size = _.get(info, 'file.size', 0);
            this.setSkyboxPicture({
                old_key: key,
                key: data.data.key,
                temp_key: info.id,
                size: size.toString(),
                extension: extension,
                uploadedBy:  info.user.first_name + ' ' + info.user.last_name,
                uploadedAt: '2023.01.01',
            });
        },
        updateEnvironmentPicture(info, data) {
           if (!_.has(data, 'data.key')) {
                return;
            }
            const extension = data.data.key.split('.').pop();
            const key = _.get(this.item.environment_picture, 'key', null);
            const size = _.get(info, 'file.size', 0);
            this.setEnvironmentPicture({
                old_key: key,
                key: data.data.key,
                temp_key: info.id,
                size: size.toString(),
                extension: extension,
                uploadedBy:  info.user.first_name + ' ' + info.user.last_name,
                uploadedAt: '2023.01.01',
            });
        },
        updateSkybox(e) {
            this.setSkybox(e.target.value);
        },
        updateEnvironment(e) {
            this.setEnvironment(e.target.value);
        },
        updateScrollingText(e) {
            this.setScrollingText(e.target.value);
        },
        updateMaxCountBooth(e) {
            this.setMaxCountBooth(e.target.value);
        },
    }
}
</script>

<style scoped>

</style>